import client from "@/utils/client";

export const getArticleSeo = (articleId: string) => {
  return client.get(`/common/seo/${articleId}`);
};

export const getFaqSeo = (pageKey: string = "faq") => {
  return client.get(`/common/faq-seo/${pageKey}`);
};

export const getTermsConditionSeo = (pageKey: string = "termsOfUse") => {
  return client.get(`/common/site-setting-seo/${pageKey}`);
};

export const getPrivacyPolicySeo = (pageKey: string = "privacyPolicy") => {
  return client.get(`/common/site-setting-seo/${pageKey}`);
};

export const getAboutUsSeo = (pageKey: string = "aboutUs") => {
  return client.get(`/common/about-us-seo/${pageKey}`);
};

export const getContactSeo = (pageKey: string = "contactPage") => {
  return client.get(`/common/content-seo/${pageKey}`);
};

export const getHomeBannerSeo = (pageKey: string = "homePage") => {
  return client.get(`/common/home-banner-seo/${pageKey}`);
};

export const getCollectionPageSeo = (pageKey: string = "collection") => {
  return client.get(`/common/collection-page-seo/${pageKey}`);
};

export const getPaymentSeo = (pageKey: string = "payment") => {
  return client.get(`/common/payment-seo/${pageKey}`);
};

export const getArticlePageSeo = (pageKey: string = "article") => {
  return client.get(`/common/article-seo/${pageKey}`);
};

export const getExplorePageSeo = (pageKey: string = "explore") => {
  return client.get(`/common/explore-seo/${pageKey}`);
};
